export const contactsDataGridColumns = [
  { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // for checkboxes
  { key: 'id', label: 'S No', sortable: true, sticky: true },
  {
    key: 'profileCreationDate',
    label: 'Date',
    sortable: true,
    sticky: false,
  },
  { key: 'profileId', label: 'Id', sortable: true, sticky: false },
  { key: 'isClient', label: 'Type', sortable: true, sticky: false },
  { key: 'firstName', label: 'Name', sortable: true, sticky: false },
  { key: 'surName', label: 'Sur Name', sortable: true, sticky: false },
  { key: 'fullAddress', label: 'Address', sortable: true, sticky: false }, // combined address, city, postcode
  { key: 'phone', label: 'Phone', sortable: true, sticky: false },
  { key: 'email', label: 'Email', sortable: true, sticky: false },
  { key: 'status', label: 'Status', sortable: true, sticky: false },

  { key: 'address', label: 'Address', sortable: true, sticky: true },
  { key: 'iban', label: 'IBan', sortable: true, sticky: false },
  { key: 'bankAccount', label: 'Bank Account', sortable: true, sticky: false },
  { key: 'bankName', label: 'Bank Name', sortable: true, sticky: false },
  {
    key: 'creationDate',
    label: 'Creation Date',
    sortable: true,
    sticky: false,
  },
  { key: 'houseNumber', label: 'House No', sortable: true, sticky: false },
  {
    key: 'houseNumberAdd',
    label: 'Address Line 1',
    sortable: true,
    sticky: false,
  },
  { key: 'city', label: 'City', sortable: true, sticky: false },
  { key: 'postCode', label: 'Post Code', sortable: true, sticky: false },
  { key: 'personId', label: 'Person Id', sortable: true, sticky: false },
  {
    key: 'exactOnlineID',
    label: 'Exact Online Id',
    sortable: true,
    sticky: false,
  },

  { key: 'exported', label: 'Exported', sortable: true, sticky: false },
  { key: 'importDate', label: 'Import Date', sortable: true, sticky: false },
  { key: 'actions', label: 'Actions', sortable: false, sticky: false }, // for buttons like Save, Edit, Delete
];
